<template>
  <SfModalPortal
    modal-id="confirm-delete-segment-modal"
    size="xs"
    @opened="bindData"
  >
    <template #title>{{ title }}</template>

    <template #body>
      <div class="tw-text-sm tw-text-center">{{ message }}</div>
      <div
        v-if="hint"
        v-dompurify-html="hint"
        class="tw-pt-2 tw-text-sf-gray-light tw-text-sm tw-text-center"
      ></div>
    </template>

    <template #footer>
      <SfButton variant="white" @click="close">{{
        I18n.t('confirmation.cancel')
      }}</SfButton>

      <SfButton variant="danger" @click="deleteQuery">{{ title }}</SfButton>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { SfLog } from '@app/adapters/logger'
import { useSegmentsStore } from '@app/insights/store/segments'
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import { SfButton } from '@app/shared/vue/components/sf-button'
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { ConfirmDeleteSegmentModalPayload } from '@app/types'

defineOptions({ name: 'ConfirmDeleteSegmentModal' })

const segmentsStore = useSegmentsStore()

const I18n = useI18n()

const id = ref(0)
const title = ref('')
const message = ref('')
const hint = ref<string | undefined>(undefined)

const bindData = (payload: ConfirmDeleteSegmentModalPayload) => {
  id.value = payload.id
  title.value = payload.title
  message.value = payload.message
  hint.value = payload.hint
}

const deleteQuery = async () => {
  try {
    await segmentsStore.deleteSegment({ id: id.value })
    segmentsStore.closeEditSegmentModal()
    segmentsStore.unselectSegment()
  } catch (e) {
    SfLog.error(`Error deleting query ${id.value}`, { error: e })
  } finally {
    close()
  }
}
const close = () => window.modalCitizen.closeModalPortal()
</script>
